import { useState } from 'react';
import {
  StoragePricingsPage,
  StoragePricingsHeader,
  StoragePricingsBody,
} from './StoragePricingsComponents';
import { RoleGuard } from '../../routes';

export const StoragePricings = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <StoragePricingsPage id={'storage-pricing-page'} innerScroll>
        <StoragePricingsHeader totalCount={totalCount} />
        <StoragePricingsBody setTotalCount={setTotalCount} />
      </StoragePricingsPage>
    </RoleGuard>
  );
};
